import dev from '../assets/dev.png'
import uiux from '../assets/ui-ux.png'
import graphic from '../assets/graphic.png'
import motions from '../assets/motion.png'
import photo from '../assets/photo.png'
import video from '../assets/vidoe.png'
import triAngle from '../assets/tri-angle.png'
import times from '../assets/times.png'
import { motion } from 'framer-motion'

const Services = () => {

    const services = [
        {
            name: 'Development',
            desc: 'Create a platform with the best and coolest quality from us.',
            image: dev
        },
        {
            name: 'UI/UX Designer',
            desc: 'We provide UI/UX Design services and of course with the best quality.',
            image: uiux
        },
        {
            name: 'Graphic Designer',
            desc: 'We provide Graphic Design services, with the best designers.',
            image: graphic
        },
        {
            name: 'Motion Graphic',
            desc: 'Create a platform with the best and coolest quality from us.',
            image: motions
        },
        {
            name: 'Photography',
            desc: 'We provide Photography services and of course with the best quality.',
            image: photo
        },
        {
            name: 'Video',
            desc: 'Create a platform with the best and coolest quality from us.',
            image: video
        }
    ]

    const variants = {
        hidden: { opacity: 0, y: 75 },
        visible: { opacity: 1, y: 0 },
    }


    return (
        <motion.div 
            id='services' 
            className="relative flex flex-col items-center py-12 px-8 tab:px-4 text-center"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }} 
            variants={variants}
            transition={{ duration: 0.5 }}
        >

            <h2 className="text-white text-4xl font-bold mb-20">
                The Service We Provide For You
            </h2>

            <img 
                src={triAngle} 
                alt="TriAngle"
                className='absolute left-20 tab:left-2 top-5 tab:-top-7 w-16' 
            />

            <img 
                src={times} 
                alt="Time"
                className='absolute right-8 top-32 w-12' 
            />

            <img 
                src={times} 
                alt="Time"
                className='absolute bottom-0 left-0 w-12' 
            />

            <motion.div 
                className="flex flex-wrap items-center justify-center gap-14"
                initial= 'hidden'
                whileInView="visible"
                viewport={{ once: true, }}
                variants={variants}
                transition={{ duration: 0.5, delay: 0.5 }}
            >
                
                {
                    services.map((sevis, index) => (
                        <motion.div 
                            key={index}
                            className='flex flex-col items-center tab:w-full w-[30%] text-center'
                            initial= 'hidden'
                            whileInView="visible"
                            viewport={{ once: false, amount: 0.3 }}
                            variants={{
                                hidden: { opacity: 0, x: -75 },
                                visible: { opacity: 1, x: 0 }
                            }}
                            transition={{ duration: 0.5, delay: 0.5, type: 'spring', stiffness: 130 }}
                        >

                            <img 
                                src={sevis.image} 
                                alt={sevis.name} 
                                className='animi w-14 mb-2 cursor-pointer hover:scale-105'
                            />

                            <h4 className='text-2xl text-white'>{sevis.name}</h4>

                            <p 
                                className='text-greys text-lg mt-3'
                            >
                                {sevis.desc}
                            </p>

                        </motion.div>
                    ))
                }

            </motion.div>

        </motion.div>
    );
}
 
export default Services;